import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import PhoenixPlanOptions from './components/phoenix-plan-options';
import WolfPlanOptions from './components/wolf-plan-options';
import SkipLink from './components/skip-link';
import { closeWebview } from '../../store/ducks/shared';
import './index.css';

export class PlanSelection extends Component {
  getPlanOptions = () => {
    if (this.props.appName === 'wolf') {
      return <WolfPlanOptions onBack={ this.closeWebview } />;
    } else {
      return <PhoenixPlanOptions />;
    }
  }

  closeWebview = () => {
    this.props.closeWebview();
  }

  render() {
    return (
      <div className="plan-selection">
        <SkipLink app={ this.props.appName } />
        { this.getPlanOptions() }
      </div>
    );
  }
}

PlanSelection.propTypes = {
  appName: PropTypes.string.isRequired,
  closeWebview: PropTypes.func.isRequired
};

export default connect(
  state => ({
    appName: state.config.appName,
  }),
  dispatch => ({
    closeWebview: () => dispatch(closeWebview())
  })
)(PlanSelection);
